<template lang='pug' src='./home.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Header from 'components/header/header'
import Hero from 'components/hero/hero'
import Footer from 'components/footer/footer'

export default {
  name: 'home',
  computed: {
    props () {
      return this.$store.state.pages.home
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    Loader,
    Header,
    Hero,
    Footer
  },
  data () {
    return {
      swiperOption2: {
        centeredSlides: true,
        loop: true,
        spaceBetween: 30,
        effect: 'slide',
        speed: 1000,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next2',
          prevEl: '.swiper-button-prev2'
        },
        pagination: {
          el: '.swiper-pagination'
        }
      },
      swiperOption3: {
        centeredSlides: true,
        loop: true,
        spaceBetween: 30,
        effect: 'slide',
        speed: 1000,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next3',
          prevEl: '.swiper-button-prev3'
        },
        pagination: {
          el: '.swiper-pagination'
        }
      },
      swiperOption4: {
        centeredSlides: true,
        loop: true,
        spaceBetween: 30,
        effect: 'slide',
        speed: 1000,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next4',
          prevEl: '.swiper-button-prev4'
        },
        pagination: {
          el: '.swiper-pagination'
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper-button-next4, .swiper-button-prev4, .swiper-button-next3, .swiper-button-prev3, .swiper-button-next2, .swiper-button-prev2, .swiper-button-prev, .swiper-button-next {
  background-color: rgba(255, 255, 255, .6);
  border: solid black 2px;
  backdrop-filter: blur(3px);
  padding: 2rem;
}
.swiper-button-next4 .div {}
.content-caption, .content-info {
}
// technology section, other sections use content-info instead of content-caption
.content-caption {
  max-width: 80vw;
  margin: 0 auto;
  margin-left: 6rem;
  padding-left: 0;
}

</style>



// WEBPACK FOOTER //
// home.vue?69a3f9aa